import Axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import { getUrl } from 'src/services/ApiService';
import { CURRENT_STS_API_VERSION, getHeaders } from 'src/services/ApiService';

export const axiosInstance = Axios.create();

// @TODO: Seperate 2 instances, one for Authz, one for STS
const apiClient = setupCache(axiosInstance, {
    cacheTakeover: false,
    interpretHeader: false,
    methods: ['get', 'head'],
    staleIfError: false,
    debug: console.log,
});

// Add required headers to the request
axiosInstance.interceptors.request.use(
    config => {
        const apiVersion = config.headers['X-API-Version'] || CURRENT_STS_API_VERSION;
        // Remove custom header so it is not sent to the server
        delete config.headers['X-API-Version'];

        const contentType = config.headers['Content-Type'] || 'application/json';
        const headersObj = getHeaders(apiVersion, true, contentType);
        Object.keys(headersObj).forEach(key => {
            config.headers[key] = headersObj[key];
        });
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#axios-basequery
export const apiBaseQuery = baseQueryOptions => {
    const { apiVersion = CURRENT_STS_API_VERSION } = baseQueryOptions || {};
    return async (args, api, extraOptions) => {
        const { url: endpoint, headers: additionalHeaders, ...rest } = args;
        const completeUrl = getUrl(endpoint);

        try {
            const result = await axiosInstance({
                url: completeUrl,
                ...rest,
                headers: {
                    ...additionalHeaders,
                    'X-API-Version': apiVersion,
                },
                cache: false,
            });
            return { data: result.data };
        } catch (axiosError) {
            const err = axiosError;
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            };
        }
    };
};

export default apiClient;
